module.exports = __webpack_public_path__ + "static/media/square-xmark.6ae87fe8.svg";